__turbopack_context__.v({
  "fadeInItems": "Link-module__dkcdzG__fadeInItems",
  "spacing--lg": "Link-module__dkcdzG__spacing--lg",
  "spacing--md": "Link-module__dkcdzG__spacing--md",
  "spacing--sm": "Link-module__dkcdzG__spacing--sm",
  "spacing--xl": "Link-module__dkcdzG__spacing--xl",
  "spacing--xs": "Link-module__dkcdzG__spacing--xs",
  "spacing--xxl": "Link-module__dkcdzG__spacing--xxl",
  "spacing--xxs": "Link-module__dkcdzG__spacing--xxs",
  "spacing--xxxl": "Link-module__dkcdzG__spacing--xxxl",
  "spacing--xxxs": "Link-module__dkcdzG__spacing--xxxs",
});
